import { useSelector } from "react-redux";

export const GetUserDetails= () => {
    const GetUserDetails = useSelector(
      (state) => state.userDetails
    );
    return GetUserDetails;
};